// extracted by mini-css-extract-plugin
export default {"NavItem":"NavItem_NavItem__vQLDE","NavItemLink":"NavItem_NavItemLink__ZqLk8","active":"NavItem_active__SCS1P"};